/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { CoreStrictHttpResponse } from '../../core-strict-http-response';
import { CoreRequestBuilder } from '../../core-request-builder';

import { CoreTimesheetResponseDto } from '../../models/core-timesheet-response-dto';

export interface TimesheetsControllerFindById$Params {

/**
 * Tenant identifier
 */
  tenant: string;

/**
 * Timesheet ID
 */
  id: string;
}

export function timesheetsControllerFindById(http: HttpClient, rootUrl: string, params: TimesheetsControllerFindById$Params, context?: HttpContext): Observable<CoreStrictHttpResponse<CoreTimesheetResponseDto>> {
  const rb = new CoreRequestBuilder(rootUrl, timesheetsControllerFindById.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as CoreStrictHttpResponse<CoreTimesheetResponseDto>;
    })
  );
}

timesheetsControllerFindById.PATH = '/o2-core/timesheets/{tenant}/id/{id}';
